import request from "@/utils/request";

const scrmBase = "/scrm";
const clientInfo = "Basic ZnVqaWU6SVlSVXZWelB5SWJXY3RaQ04zY21yUXRnMWkwRWt6UjY=";

// 本地设置
/**
 * 获取验证码
 */
export function getCaptcha() {
  return request({
    url: `${scrmBase}/oauth2/getCaptcha`,
    method: "post",
    isWithoutToken: true,
  });
}

/**
 * 登录
 * @param { string } grant_type password
 * @param { string } username
 * @param { string } password
 * @param { string } captchaCode
 * @param { string } captchaUuid
 * clientId:  fujie
 * clientSecret:  IYRUvVzPyIbWctZCN3cmrQtg1i0EkzR6
 */
export function login(data) {
  return request({
    url: `${scrmBase}/oauth2/token`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: clientInfo,
    },
    isWithoutToken: true,
    method: "post",
    data: data,
  });
}

/**
 * 查询当前用户菜单
 */
export function queryMenus(data) {
  return request({
    // url: '/menu.json',
    url: `${scrmBase}/menu/queryAccessibleMenus`,
    method: "post",
    data: data,
  });
}

/**
 * 根据token查询用户信息
 */
export function queryUserInfo(data) {
  return request({
    url: `${scrmBase}/user/getUserInfoByToken`,
    method: "post",
    data: data,
  });
}

/**
 * 刷新token - 根据refresh_token
 * @param { string } grant_type refresh_token
 * @param { string } refresh_token
 * clientId:  fujie
 * clientSecret:  IYRUvVzPyIbWctZCN3cmrQtg1i0EkzR6
 */
export function refreshLogin(data) {
  return request({
    url: `${scrmBase}/oauth2/token`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: clientInfo,
    },
    isWithoutToken: true,
    method: "post",
    data: data,
  });
}

/**
 * 退出登录
 */
export function loginOut(data) {
  return request({
    url: `${scrmBase}/user/logout`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "post",
    data: data,
  });
}